import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';

import StyledContainer from '../../../../shared/components/styled-container/styled-container';
import { useOnFeatureClearingStates } from '../../../../shared/hooks/use-on-feature-clearing-states/use-on-feature-clearing-states.hook';
import { useRouteRedirect } from '../../../../shared/hooks/use-route-redirect/use-route-redirect.hook';
import {
  clearFirmwareFilters,
  clearFirmwaresState,
} from '../../../firmware-management/store/slices/firmware.slice';
import SnackBarContextProvider from '../../../shared/components/snack-bar-context/SnackBarContext';
import { resetVehicleReports } from '../../store/slices/campaign-reports.slice';
import { resetBasicInfo } from '../../store/slices/campaigns-basic-info.slice';
import { resetVehiclePopulation } from '../../store/slices/campaigns-vehicle-population.slice';
import {
  clearCampaignFilters,
  clearCampaignsState,
} from '../../store/slices/campaigns.slice';

const CampaignsManagementPageLayout: FunctionComponent = (): JSX.Element => {
  useOnFeatureClearingStates([
    clearFirmwareFilters(),
    clearFirmwaresState(),
    resetBasicInfo(),
    resetVehiclePopulation(),
    resetVehicleReports(),
    clearCampaignFilters(),
    clearCampaignsState(),
  ]);

  useRouteRedirect('/campaign-management', 'campaigns');

  return (
    <SnackBarContextProvider>
      <StyledContainer maxWidth={false} data-testid="main-campaigns-page">
        <Outlet />
      </StyledContainer>
    </SnackBarContextProvider>
  );
};

export default CampaignsManagementPageLayout;
